import { readWholeList } from '../core-api-client/core-api-client.utils.js';
/**
 * A municipality's roles from one page of the list, which throws if there are more: the query's
 * `select`, shared by the hook and by callers that run it for a list of ids.
 */
export function selectWholeMunicipalityRoles(response) {
    return readWholeList({
        items: response.data.roles,
        hasMore: response.data.pagination.hasMore,
        listName: 'municipality roles',
    });
}
